import React from "react";
import { Handshake, Map, Search } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
const advantages = [{
  title: "Priority Booking",
  description: "Members receive first-access scheduling for all IV therapy and wellness services, ensuring your protocol fits your busy lifestyle.",
  icon: Handshake,
  bgColor: "bg-green-accent/10"
}, {
  title: "Member-Only Pricing",
  description: "Unlock exclusive preferred rates on vitamin injections, lab testing, and our full suite of medical-grade wellness treatments.",
  icon: Map,
  bgColor: "bg-green-accent/10"
}, {
  title: "Curated Wellness",
  description: "Personalized health tracking and custom-tailored protocols designed by our medical experts to optimize your long-term vitality.",
  icon: Search,
  bgColor: "bg-green-accent/10"
}];
export default function TheNeighborlyAdvantage() {
  return <section data-section-id="223484" id="membership-benefits" className="dark w-full bg-green-accent py-20 md:py-28">
      <div className="container mx-auto px-4 md:px-6">
        <div className="rounded-3xl border-2 border-green-accent bg-green-accent px-6 py-16 md:px-12 md:py-20 lg:px-16 relative overflow-hidden">
          <div className="absolute inset-0 bg-gold-accent/30 backdrop-blur-[2px]" />
          
          <div className="relative z-10 mx-auto mb-16 max-w-2xl text-center">
            <div className="absolute inset-0 -z-10 bg-background/80 rounded-2xl blur-xl" />
            <div className="relative bg-green-accent p-8 rounded-2xl border border-green-accent shadow-[0_4px_20px_rgba(168,144,128,0.15)]">
              <h2 className="font-serif text-4xl font-normal tracking-tight text-white md:text-5xl">
                The Protocol Membership
              </h2>
              <p className="mt-4 text-lg text-white/90 font-default">
                Elevate your health with exclusive access to the new standard in medical wellness and precision care.
              </p>
            </div>
          </div>

          <div className="grid grid-cols-1 gap-8 md:grid-cols-3 relative z-10">
            {advantages.map((item, i) => {
            const Icon = item.icon;
            return <Card key={i} data-index={i} className={`group border-2 border-border/20 shadow-lg transition-all duration-500 hover:border-primary/30 hover:shadow-[0_0_30px_rgba(255,255,255,0.05)] bg-green-accent`}>
                  <CardHeader className="pb-4">
                    <div className="mb-4 inline-flex h-16 w-16 items-center justify-center rounded-full bg-gold-accent/20 text-white transition-transform duration-500 ease-out group-hover:-translate-y-2">
                      <Icon className="h-8 w-8 stroke-[1]" />
                    </div>
                    <CardTitle className="font-serif text-2xl font-normal text-white">
                      <h3>{item.title}</h3>
                    </CardTitle>
                  </CardHeader>
                  <CardContent>
                    <p className="leading-relaxed text-white font-default">
                      {item.description}
                    </p>
                  </CardContent>
                </Card>;
          })}
          </div>
        </div>
      </div>
    </section>;
}